<div class="message-history-dialog">
    <div class="dialog-header">
        <h1 mat-dialog-title>{{ data.title }}</h1>
        <button mat-icon-button (click)="onClose()" class="close-button">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    
    <div mat-dialog-content>
        <div class="example-header">
            <mat-form-field class="filter-field">
                <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter" autocomplete="off" [(ngModel)]="filter">
                <button mat-button *ngIf="filter !== ''" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilters()">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>

        <div class="table-container" *ngIf="data.messages && data.messages.length > 0">
            <mat-table class="compact" [dataSource]="dataSource" matSort>
                <ng-container matColumnDef="documentType">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="align-left"> DOCUMENT TYPE </mat-header-cell>
                    <mat-cell *matCellDef="let element" class="align-left"> {{element.documentType}} </mat-cell>
                </ng-container>
                <ng-container matColumnDef="documentId">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="align-left"> DOCUMENT NUMBER </mat-header-cell>
                    <mat-cell *matCellDef="let element" class="align-left">
                        <a href="javascript:void(0)" class="actionButton" (click)="openMessageDetails(element)">
                            {{element.documentId}}
                        </a>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="systemDate">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="align-left"> RECEIVED DATE </mat-header-cell>
                    <mat-cell *matCellDef="let element" class="align-left">{{ element.systemDate | date:'MM/dd/yyyy HH:mm:ss' }}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="customerNumber">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="align-left"> CUSTOMER NUMBER </mat-header-cell>
                    <mat-cell *matCellDef="let element" class="align-left">{{element.customerNumber}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="referenceID">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="align-left"> REFERENCE NUMBER </mat-header-cell>
                    <mat-cell *matCellDef="let element" class="align-left">{{element.referenceID}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="statusFlag">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="align-center"> PROCESSED </mat-header-cell>
                    <mat-cell *matCellDef="let element" class="align-center">
                        <ng-container *ngIf="element.statusFlag else elseTemplate">
                            Y
                        </ng-container>
                        <ng-template #elseTemplate>
                            N
                        </ng-template>
                    </mat-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            </mat-table>

            <div class="paginator-container">
                <mat-paginator [hidePageSize]="true" [pageSize]="10" showFirstLastButtons></mat-paginator>
            </div>
        </div>

        <div class="no-records" *ngIf="!data.messages || data.messages.length === 0">
            <p>No message history found.</p>
        </div>
    </div>

    <div mat-dialog-actions class="dialog-actions">
        <button mat-raised-button color="btnprimary" (click)="onClose()">Close</button>
    </div>
</div>

